import Vue from "vue";
import App from "@/App";
import router from "@/router/index";
import store from "./store";
import pageTitle from "@/components/page-title";
import directive from '@/directives'
import "@/element";

// 入口样式文件
import "@/assets/css/index.css";

Vue.component("pageTitle", pageTitle);
Vue.config.productionTip = false;
Vue.directive('has-button', directive);

router.beforeEach(async (to, from, next) => {
  if (store.state.token) {
    if (to.path !== "/login" && !store.state.permissionRoutesList.length) {
      const res = await store.dispatch("GET_PERMISSION_ROUTES_LIST");
      if (res.success) {
        next(to.fullPath);
      }else{
        store.dispatch('SET_USER_LOGOUT')
        next("/login");
      } 
    } else {
      next();
    }
  } else {
    if (to.path !== "/login") {
      next("/login");
    } else {
      next();
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
